import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Table, Spin, Empty, Pagination, Flex, Card, Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { fetchAllVisitors } from '../../store/visitorSlice';
import { PageWrapper, Title, Description } from './visitors.styles';
const VisitorsPage = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 10;
    const siteId = useSelector((state) => state?.site?.checkSite?.response?.data?.siteId);
    const visitorsData = useSelector((state) => state?.visitor?.visitors);
    const { loading, response } = visitorsData;
    // Fetch all visitors on component mount
    useEffect(() => {
        if (siteId) {
            dispatch(fetchAllVisitors({ siteId, pageNumber: 0, pageSize }));
        }
    }, [siteId, dispatch]);
    const handlePageChange = (page) => {
        setCurrentPage(page);
        dispatch(fetchAllVisitors({ siteId: siteId || '', pageNumber: page - 1, pageSize }));
    };
    const columns = [
        {
            title: 'Phone Number',
            dataIndex: 'phoneNumber',
            key: 'phoneNumber',
            width: '100%',
            render: (text) => _jsx("span", { children: text || '-' }),
        },
    ];
    return (_jsxs(PageWrapper, { children: [_jsxs(Flex, { align: "center", gap: 12, style: { marginBottom: '24px' }, children: [_jsx(Button, { type: "text", icon: _jsx(ArrowLeftOutlined, {}), onClick: () => navigate('/editor'), style: { padding: 0 } }), _jsx(Title, { children: "Visitors" })] }), _jsx(Card, { style: { marginBottom: '24px' }, children: _jsx(Description, { children: "All visitor phone numbers are displayed below." }) }), _jsx(Card, { children: loading ? (_jsx("div", { style: { display: 'flex', justifyContent: 'center', padding: '40px' }, children: _jsx(Spin, { size: "large" }) })) : response && response.content && response.content.length > 0 ? (_jsxs(_Fragment, { children: [_jsx(Table, { columns: columns, dataSource: response.content.map((item, index) => ({
                                ...item,
                                key: item.visitorId || index,
                            })), pagination: false, size: "middle", scroll: { x: 600 }, style: { marginBottom: '16px' } }), _jsxs(Flex, { justify: "space-between", align: "center", children: [_jsxs("span", { style: { color: '#666' }, children: ["Showing ", (currentPage - 1) * pageSize + 1, " to", ' ', Math.min(currentPage * pageSize, response.totalElements), " of", ' ', response.totalElements, " visitors"] }), _jsx(Pagination, { current: currentPage, pageSize: pageSize, total: response.totalElements, onChange: handlePageChange, showSizeChanger: false })] })] })) : (_jsx(Empty, { description: "No visitors available", style: { padding: '40px' } })) })] }));
};
export default VisitorsPage;
